import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'pref-facet-subject',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class PrefFacetSubject extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop()
    private value: any;

    @Prop()
    private isReadOnly: any;

    @Prop()
    private categorySubjectData: any;

    private categoryList: any = [];

    private dataPropsValues: any = [];

    private dataStringValue: any = '';

    private content: any = [];

    private isExpand: boolean = false;

    private indexNumber: number = 5;

    @Watch('categorySubjectData')
    private onWatchData(data: any) {
        if (data && data.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    // ---------------------------------------------------------------------
    // Methods

    private created() {
        this.content = this.value;
        if (this.isReadOnly) {
            // this.fetchDisplayProp();
        }
    }

    private mounted() {
        if (this.categorySubjectData && this.categorySubjectData.length > 0) {
            this.fetchDisplayPropParent();
        }
    }

    private async fetchDisplayPropParent() {
        const categoryList = this.categorySubjectData;
        // const valueData: any = [ "K12.MA", "HE.CS", "HE.BS", "K12.MA", "HE.CS", "HE.BS" ];
        const valueData: any = this.content;
        const dataValuesCalculate: any = [];

        for (const prop of valueData) {
            const propSplit = prop.split('.');
            const data: any = {
                keyName: prop,
                categoryId: propSplit[0],
                subjectId: prop,
            };
            dataValuesCalculate.push(data);
        }
        for await (const [index, iterator] of dataValuesCalculate.entries()) {
            const selectedCategoryIndex = categoryList.findIndex((catItem: any) => {
                return catItem.code === iterator.categoryId;
            });
            if (selectedCategoryIndex !== -1) {
                const selectedSubjectIndex = categoryList[selectedCategoryIndex].subjectList.findIndex((item: any) => {
                    return item.id === iterator.subjectId;
                });
                const selectedSubject = categoryList[selectedCategoryIndex].subjectList[selectedSubjectIndex];
                iterator.subjectTitle = selectedSubject.title;
            }
        }
        this.dataPropsValues = dataValuesCalculate;
    }

    private getSubjectList(categoryId: string) {
        return taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            return subjectList;
        });
    }

    private makeStringToShow() {
        const dataValue = this.dataPropsValues;
        let emptyString = '';
        for (const iterator of dataValue) {
            emptyString += `${iterator.categoryId} - ${iterator.subjectTitle} ; `;
        }
        this.dataStringValue = emptyString;
    }

    private showMore() {
        this.indexNumber = this.indexNumber + 5;
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }
}
